import React, { useEffect, useState } from 'react';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';

export default function PriceRangeSlider({ urlParams, setUrlParams, min_value, max_value, currency }) {

  const [minimum_value,setminimum_value] = useState(0);
  const [maximum_value,setmaximum_value] = useState(0);

  const handleChange = (values) => {
    setminimum_value(values[0])
    setmaximum_value(values[1])
  };

  useEffect(() => {
    var queryObj = {};
    for (const entry of urlParams.entries()) {
      queryObj = Object.fromEntries([...urlParams]);
    }
    const matched = Object.entries(queryObj).reduce((acc, [key, value]) => {
      if (key === 'min' || key === 'max') {
        acc[key] = value;
      }
      return acc;
    }, {});

    const priceInput = Object.keys(matched).length ? [matched] : [];
    if (priceInput.length > 0) {
      setminimum_value(parseFloat(priceInput[0].min))
      setmaximum_value(parseFloat(priceInput[0].max))
    }else{
      setminimum_value(min_value)
      setmaximum_value(Math.round(max_value))
    }
  }, [])


  const handleInputChange = (event) => {
    if(event.target.name == 'min'){
      setminimum_value(event.target.value)
    }
    if(event.target.name == 'max'){
      setmaximum_value(event.target.value)
    }
  }

  const handleApply = () =>{
        urlParams.set('min',minimum_value)
        urlParams.set('max',maximum_value)
        setUrlParams(urlParams)
  }

  const handleClear = () =>{
        urlParams.delete('min')
        urlParams.delete('max')
        setUrlParams(urlParams)
  }



  return (
    <div className='mb-4'>
      <div className='pricerange-title'>Price Range </div>
      <RangeSlider
        min={min_value}
        max={max_value}
        step={1}
        value={[minimum_value,maximum_value]}
        onInput={handleChange}
      />
      <div className='d-flex align-items-center mt-3 '>
        <div style={{ fontWeight: 600, fontSize: 14 }}>
          <div>Min</div>
          <input type='text' className='mt-1 slider_range_input_box' name={'min'} value={minimum_value} onChange={handleInputChange} />
        </div>
        <div style={{ fontWeight: 600, fontSize: 14 }} className='mt-4 mx-4'>to</div>
        <div style={{ fontWeight: 600, fontSize: 14 }}>
          <div>Max</div>
          <input type='text' className='mt-1 slider_range_input_box' name={'max'} value={maximum_value} onChange={handleInputChange} />
        </div>
      </div>

      <div className='d-flex align-items-center justify-content-end mt-4'>
        <div className='clear_all cursor-pointer' onClick={handleClear}>Clear All</div>
        <div className='ms-3 apply_btn cursor-pointer' onClick={handleApply}>Apply</div>
      </div>

      {/* <div className='pricerange-price'>{currency} {priceRange.length > 0 ? priceRange[0] : 10} - {currency} {priceRange.length > 0 ? priceRange[1] : max_value}</div> */}

    </div>
  );
}
